import React from 'react';
import { SportList } from '../../helper/SportActivities';
import SportCard from './sport/SportCard';
import styled from 'styled-components'

const SportsActivities = () => {
  return (
    <Wrapper>
      <h1>Sports Activities</h1>
      <section className="container">
        {SportList.map((sport) => (
          <SportCard key={sport.id} {...sport} />
        ))}
      </section>
    </Wrapper>
  );
};
const Wrapper = styled.section`
.container{
    margin-top:100px;
    display: grid !important;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: 1fr;
    gap: 20px;
    @media (max-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media (max-width: 480px) {
      grid-template-columns: 1fr;
    }
}
    
`
export default SportsActivities;